import { nanoid } from "nanoid";

export function peregrineId() {
  return ';'+nanoid(22);
}